"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _slicedToArray = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _templateObject;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var formats_1 = require("./formats");

var limit_1 = require("./limit");

var codegen_1 = require("ajv/dist/compile/codegen");

var fullName = new codegen_1.Name("fullFormats");
var fastName = new codegen_1.Name("fastFormats");

var formatsPlugin = function formatsPlugin(ajv) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    keywords: true
  };

  if (Array.isArray(opts)) {
    addFormats(ajv, opts, formats_1.fullFormats, fullName);
    return ajv;
  }

  var _ref = opts.mode === "fast" ? [formats_1.fastFormats, fastName] : [formats_1.fullFormats, fullName],
      _ref2 = _slicedToArray(_ref, 2),
      formats = _ref2[0],
      exportName = _ref2[1];

  var list = opts.formats || formats_1.formatNames;
  addFormats(ajv, list, formats, exportName);
  if (opts.keywords) limit_1.default(ajv);
  return ajv;
};

formatsPlugin.get = function (name) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "full";
  var formats = mode === "fast" ? formats_1.fastFormats : formats_1.fullFormats;
  var f = formats[name];
  if (!f) throw new Error("Unknown format \"".concat(name, "\""));
  return f;
};

function addFormats(ajv, list, fs, exportName) {
  var _a;

  var _b;

  (_a = (_b = ajv.opts.code).formats) !== null && _a !== void 0 ? _a : _b.formats = codegen_1._(_templateObject || (_templateObject = _taggedTemplateLiteral(["require(\"ajv-formats/dist/formats\").", ""])), exportName);

  var _iterator = _createForOfIteratorHelper(list),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var f = _step.value;
      ajv.addFormat(f, fs[f]);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

module.exports = exports = formatsPlugin;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatsPlugin;